import { Box, Button, CircularProgress, Divider } from "@mui/material";
import { useToast } from "../../../../../../../../Components/Provider/ToastProvider";
import useAreaOfInterest from "../../../../../../../../hooks/useAreaOfInterest";
import DialogConfirmation from "../Confirmation";
import { useState } from "react";

const commonButtonWidth = {
  width: {
    lg: "120px",
    xl: "120px",
  },
} as const;
type AreaOfInterestAttributes = {
  country: string;
  file: File[];
  areaOfInterestName: string;
  idAttribute: string;
  nameAttribute: string;
};

const Footer = ({
  attributes,
  disabled,
}: {
  attributes: AreaOfInterestAttributes;
  disabled: boolean;
}) => {
  const { showToast } = useToast();
  const { postAreaOfInterest } = useAreaOfInterest();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const disableUploadDocs = () => {
    const { country, file, areaOfInterestName, idAttribute } = attributes;

    return (
      !country ||
      file.length === 0 ||
      !areaOfInterestName.trim() ||
      !idAttribute.trim()
    );
  };

  const handleUploadAreaOfInterestFile = async () => {
    try {
      if (disableUploadDocs()) {
        showToast(
          "error",
          "Please complete all required fields before continuing: AOI name, ID attribute, name attribute, file upload, and target country.",
        );
      } else {
        const response = await postAreaOfInterest.mutateAsync({
          ...attributes,
        });

        if (response) {
          showToast("success", "Area of interest saved.");
          setOpenConfirmation(true);
        }
      }
    } catch (error: any) {
      showToast(
        "error",
        error?.response?.data?.errors[0]?.message ??
          "We couldn’t save the area of interest. Please try again.",
      );
    } finally {
    }
  };

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 1,
        maxHeight: "66px",
        backgroundColor: "white",
      }}
      flex={1}
      width="100%"
    >
      <Divider />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          paddingY: "15px",
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          sx={{
            borderColor: "#2D3648",
            textTransform: "none",
            color: "#2D3648",
            ...commonButtonWidth,
          }}
          disabled={true}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleUploadAreaOfInterestFile}
          sx={{
            backgroundColor: "#2D3648",
            textTransform: "none",
            ...commonButtonWidth,
          }}
          disabled={postAreaOfInterest.isLoading || !disabled}
        >
          {postAreaOfInterest.isLoading ? (
            <CircularProgress sx={{ color: "white" }} size={20} />
          ) : (
            "Next"
          )}
        </Button>
      </Box>
      {openConfirmation && (
        <DialogConfirmation
          open={openConfirmation}
          setOpen={setOpenConfirmation}
        />
      )}
    </Box>
  );
};

export default Footer;
